<template>
    <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 579.5 413.2">  
        <path class="path" d="M94.4,188.9l143.9,151.7L523.7,34.9" :class="{'checked' :checked}"/>
    </svg>
</template>

<script setup>
    import { ref } from 'vue';
    const props = defineProps({
        checked: Boolean
    });
</script>


<style scoped> 

    path {
        fill: none;
        stroke: #AB9670;
        stroke-miterlimit: 10;
        stroke-width: 74px;
        
        transition: stroke-dashoffset .2s ease;
        stroke-dasharray: 629;
        stroke-dashoffset: 629;
    }

    path.checked{
        
        stroke-dashoffset: 0;
    }

</style>